import { Component } from "vue-property-decorator";

export default class EditAuditForm {
  public id: string = ''
  public date: string = '';
  public shift: string = '';
  public components: {name: string, id: number, status: string} []  = [];
  public ticket: string = '';
  public time: number;
}
